import { useMemo } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";

/**
 * Custom hook that finds and returns the available choices for the current command step
 *
 * @param {Object} engine - The CommandFlowEngine instance
 * @return {Array|null} Available choices for the current step or null
 */
export const useCurrentStepChoices = (engine) => {
  const inSession = useCommandFlowStore((state) => state.inSession);

  // Get the current step index as a dependency to ensure re-computation when step changes
  const currentStepIndex = engine?.sessionManager?.getCurrentStepIndex?.() || 0;

  return useMemo(() => {
    if (!inSession || !engine || !engine.sessionManager.isInSession()) {
      return null;
    }

    // Get the current step directly from the session manager
    const currentStep = engine.sessionManager.getCurrentStep();

    if (currentStep && currentStep.choices) {
      return currentStep.choices;
    }

    return null;
  }, [inSession, engine, currentStepIndex]); // Added currentStepIndex to dependencies
};
